<div class="setting-page">
  <legend>Statistics</legend>
  <arm-form (submitForm)="submit()"  [disableSubmit]="!canSubmit">
    <arm-form-title>statistics retention policy</arm-form-title>
    <div class="settings-section">
      <p>
        <mat-form-field class="halfWidth">
          <mat-label>Number of days to keep calls quotas statistics</mat-label>
          <input type="number" [(ngModel)]="statisticsSettings.historyInDaysQuota" matInput name="quotasDays"  [min]="minDaysforQouta" [max]="maxDaysForQuota" required>
          <mat-error>
            value range between {{minDaysforQouta}} to {{maxDaysForQuota}}
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <mat-form-field class="halfWidth">
          <mat-label>Number of days to keep statistics</mat-label>
          <input type="number" [(ngModel)]="statisticsSettings.historyInDays" matInput name="statisticsDays"  [min]="minDaysForStatistics" [max]="maxDayForStatistics" required>
          <mat-error>
            value range between {{minDaysForStatistics}} to {{maxDayForStatistics}}
          </mat-error>
        </mat-form-field>
      </p>

    </div>
  </arm-form>
</div>
